var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_2162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50054 12.6668C9.33824 12.6668 9.18308 12.6003 9.07145 12.4832L4.9152 8.129C4.55499 7.75216 4.82258 7.12516 5.34429 7.12516H7.52137V2.57308C7.52137 2.02762 7.96549 1.5835 8.51095 1.5835H10.4901C11.0356 1.5835 11.4797 2.02762 11.4797 2.57308V7.12516H13.6568C14.1785 7.12516 14.4461 7.75216 14.0859 8.129L9.92962 12.4832C9.81799 12.6003 9.66283 12.6668 9.50054 12.6668Z",
    fill: "#009EBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6146 17.4167H1.38542C0.621458 17.4167 0 16.7952 0 16.0312V15.6354C0 14.8715 0.621458 14.25 1.38542 14.25H17.6146C18.3785 14.25 19 14.8715 19 15.6354V16.0312C19 16.7952 18.3785 17.4167 17.6146 17.4167Z",
    fill: "#009EBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_2162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download_icon.daaa8995.svg";
export { ForwardRef as ReactComponent };